import { render, staticRenderFns } from "./Notification.view.vue?vue&type=template&id=58939b90&scoped=true"
import script from "./Notification.view.vue?vue&type=script&lang=ts"
export * from "./Notification.view.vue?vue&type=script&lang=ts"
import style0 from "./Notification.view.vue?vue&type=style&index=0&id=58939b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58939b90",
  null
  
)

export default component.exports